/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';

	const initTag = ()=> {
		if($('.js-about_tag').length) {
			$('.js-about_tag').find('.about-story-tab-item').each((idx, val) => {
				if($(val).children().attr('href').replace('index.html','') === location.pathname.replace('index.html','')) {
					$(val).addClass(a);
				}
			})
		}
		if($('.js-current-story').length) {
			console.log($('.js-current-story').find('.about-story-current-story'));
			$('.js-current-story').find('.about-story-current-story').each((idx, val) => {
				console.log($(val).attr('id'));
				console.log(location.pathname.replace('index.html',''));
				const pattern = $(val).attr('id')
				const string = location.pathname.replace('index.html','')
				console.log((string.lastIndexOf(pattern) + pattern.length === string.length) && (pattern.length <= string.length));
				if((string.lastIndexOf(pattern) + pattern.length === string.length) && (pattern.length <= string.length)) {
					$(val).addClass(a);
				}
			})
		}
	}

	const initDropdown = ()=> {
		if($('.js-about_dropdown').length) {
			$('.js-about_dropdown').find('.mod-dropdown-item').each((idx, val) => {
				if(location.pathname.indexOf($(val).children().attr('href').replace('index.html','')) != -1) {
					$(val).addClass(a);
					$('.js-about_dropdown').find('.mod-dropdown-top').each((idx2, val2) => {
						if($(val2).text() === $(val).text()) {
							$(val2).addClass(a);
						}
					})
				}
			});
		}
	}

	initTag();
	initDropdown();


})(window.jQuery, window.FUNCTIONS);
